export const SET_INITIAL_DATA = 'SET_INITIAL_DATA';

export const FETCH_AWARDS_SUCCESS = 'FETCH_AWARDS_SUCCESS';

export const ADD_NEW_AWARD = 'ADD_NEW_AWARD';
export const REMOVE_AWARD = 'REMOVE_AWARD';
